import React from 'react';
//import {authRoles} from '../../auth';

export const CompanyUpdateConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    auth: ['master', 'rh', 'rh_not_signer'],
    routes: [{
        path: '/company-details/:id',
        component: React.lazy(() =>
            import ('./CompanyUpdate'))
    }]
};